import React from 'react'

const Avatar = React.lazy(() => import('@mui/material/Avatar'))

function stringToColor(string) {
  let hash = 0
  let i

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.substr(-2)
  }
  /* eslint-enable no-bitwise */

  return color
}

function stringAvatar(name, sx) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      ...sx,
    },
  }
}

const UserAvatar = ({ user, size = 40 }, ref) => {
  /* TODO: Get user avatar image */
  const getInitial = (str = '') => {
    const trimmedString = str?.trim()
    if (trimmedString.length > 0) {
      return trimmedString[0].toUpperCase()
    }
    return ''
  }
  const getUserInitials = () => {
    if (!user) {
      return ''
    }

    let initials = ''

    if (user.firstName) {
      initials += getInitial(user.firstName)
      if (user.lastName) {
        initials += getInitial(user.lastName)
      }
    } else {
      initials += getInitial(user?.email)
    }

    return initials
  }

  const sx = { width: size, height: size }

  return (
    <React.Suspense fallback={<div className='fallback-avatar' style={sx} />}>
      <Avatar ref={ref} {...stringAvatar(user.email || '', sx)}>
        {getUserInitials()}
      </Avatar>
    </React.Suspense>
  )
}

export default React.forwardRef(UserAvatar)
